import GuidLookupListResultModelBase from '../_generated/modelBases/guid-lookup-list-result-model-base';

export default class GuidLookupListResultModel extends GuidLookupListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
